import axios from "axios";

export const state = {
    appbookings: [],
};

export const getters = {
    appbookings: state => state.appbookings,
};

export const mutations = {
    setAppBookings(state, newValue) {
        state.appbookings = newValue
    },
};

export const actions = {
    fetchAppBookings({ commit }) {
        axios.get('/appbookings').then(res => {
            commit('setAppBookings', res.data.appointments)
        })
    },
};
